import React, { Component } from "react";
import _ from "lodash";
import classnames from "classnames";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faSearch,
    faExternalLink,
    faTimes,
    faChevronRight,
} from "@fortawesome/pro-light-svg-icons";

import { Props } from "../../propTypes";
import { Campus } from "../../../store/main/types";
import { Helpers } from "../common/helpers";
import process from "process";

type State = {
    query: string;
    campusSearchMatches: Campus[];
};

type PropsParams = {
    selectedCampus: string;
    changeCampus: Function;
    blockedCampus: string[];
    closeCampusFilter: Function;
};

const torontoCampusValue = process.env
    .NEXT_PUBLIC_EC_TORONTO_CAMPUS_VALUE as string;
const torontoUrlValue = process.env.NEXT_PUBLIC_EC_TORONTO_URL as string;

export default class CampusFilter extends Component<
    Props & PropsParams,
    State
> {
    private readonly helpers = new Helpers();
    state: State = {
        query: "",
        campusSearchMatches: [],
    };

    clearQuery(i: string) {
        const { query, campusSearchMatches } = this.state;

        this.props.changeCampus(this.helpers.campusFilterName, i);

        if (query || !_.isEmpty(campusSearchMatches)) {
            this.setState({
                query: "",
                campusSearchMatches: [],
            });
        }
    }

    getCampusName = (campusSlug: string) => {
        let campusName = "";

        this.props.main.campuses.forEach((campus) => {
            if (campus.slugName === campusSlug) {
                campusName = campus.name;
            }
        });

        return campusName;
    };

    campusItemToShow(
        key: number,
        item: Campus,
        selected: boolean,
        blocked?: boolean
    ) {
        return (
            <li
                key={key}
                id={`cc-egroups-search-campus-community-${item.slugName}`}
                className={classnames(
                    `campus-filter regular prim-font flex flex-align-center flex-justify-spacebetween cursor-pointer p-spacer-xs  ${
                        item.name === "Elevation Online" ? "hide" : ""
                    }`,
                    {
                        active: selected,
                    }
                )}
                onClick={() => {
                    if (
                        !selected &&
                        item.id !==
                            (process.env
                                .NEXT_PUBLIC_EC_TORONTO_CAMPUS_ID as string)
                    )
                        this.clearQuery(item.slugName);
                    if (
                        item.id ===
                            (process.env
                                .NEXT_PUBLIC_EC_TORONTO_CAMPUS_ID as string) &&
                        process.browser
                    )
                        window.location.href =
                            process.env.NEXT_PUBLIC_EC_TORONTO_URL;
                }}
            >
                <span>
                    {item.name === "Winston Salem"
                        ? "Winston-Salem"
                        : item.name}
                </span>
                <span className="p-r-spacer-md">
                    <FontAwesomeIcon
                        className="font-size-14 campus-filter-icon not-clickable"
                        icon={faChevronRight}
                        size="1x"
                    />
                </span>
            </li>
        );
    }

    handleSearch(event: React.ChangeEvent<HTMLInputElement>) {
        const { query } = this.state;

        const campuses = this.props.main.campuses;
        const campusSearchMatches = campuses.filter(function (el) {
            let searchValue = el.name.toLowerCase();

            return searchValue.indexOf(event.target.value.toLowerCase()) !== -1;
        });

        this.setState({
            query: event.target.value.toLowerCase(),
            campusSearchMatches: campusSearchMatches,
        });
    }

    renderCampusOptions() {
        const { query, campusSearchMatches } = this.state;
        const campuses = this.props.main.campuses;

        return (
            <>
                {(query && !_.isEmpty(campusSearchMatches)) || query
                    ? campusSearchMatches
                          .sort((a, b) => {
                              const nameA = a.name.toUpperCase(); // ignore upper and lowercase
                              const nameB = b.name.toUpperCase(); // ignore upper and lowercase
                              if (nameA < nameB) {
                                  return -1;
                              }
                              if (nameA > nameB) {
                                  return 1;
                              }

                              return 0;
                          })
                          //   .filter(
                          //       (a) =>
                          //           a.id !==
                          //           (process.env
                          //               .NEXT_PUBLIC_EC_TORONTO_CAMPUS_ID as string)
                          //   )
                          .map((campus: Campus, key: number) => {
                              const isSelected =
                                  _.indexOf(
                                      this.props.selectedCampus,
                                      campus.slugName
                                  ) > -1;

                              return this.campusItemToShow(
                                  key,
                                  campus,
                                  isSelected
                              );
                          })
                    : [...campuses]
                          .sort((a, b) => {
                              const nameA = a.name.toUpperCase(); // ignore upper and lowercase
                              const nameB = b.name.toUpperCase(); // ignore upper and lowercase
                              if (nameA < nameB) {
                                  return -1;
                              }
                              if (nameA > nameB) {
                                  return 1;
                              }

                              return 0;
                          })
                          //   .filter(
                          //       (a) =>
                          //           a.id !==
                          //           (process.env
                          //               .NEXT_PUBLIC_EC_TORONTO_CAMPUS_ID as string)
                          //   )
                          .map((campus: Campus, key: number) => {
                              const isSelected =
                                  _.indexOf(
                                      this.props.selectedCampus,
                                      campus.slugName
                                  ) > -1;

                              return this.campusItemToShow(
                                  key,
                                  campus,
                                  isSelected
                              );
                          })}
            </>
        );
    }
    content = () => (
        <div className="full-height accordion-wrapper m-t-spacer-xs rel-pos">
            <div className="flex flex-wrap full-width full-height">
                <div className="flex flex-row flex-align-center flex-justify-between full-width">
                    <div className="ec-secondary-font">Campus Community</div>
                    <div
                        onClick={() => {
                            this.props.closeCampusFilter();
                        }}
                        className="cursor-pointer"
                    >
                        <FontAwesomeIcon icon={faTimes} />
                    </div>
                </div>

                <section id="campus-filters" className="full-width full-height">
                    <div className="full-width rel-pos">
                        <input
                            placeholder="Search Campus Communities"
                            className="ht-36 full-width m-y-spacer-md background-off-white ec-border-radius-sm b-width-none p-l-spacer-sm p-r-spacer-xl"
                            value={this.state.query}
                            onChange={(e) => this.handleSearch(e)}
                        />
                        <FontAwesomeIcon
                            icon={faSearch}
                            className="abs-pos abs-y-center stayright m-r-spacer-md"
                        />
                    </div>
                    <div
                        className="overflow-auto"
                        style={{ height: "calc(100% - 93px)" }}
                    >
                        <ul className="p-l-spacer-none">
                            {this.renderCampusOptions()}
                            {process.env.NEXT_PUBLIC_EC_TORONTO_URL ? (
                                <li className="m-t-spacer-md">
                                    {torontoCampusValue
                                        .toLowerCase()
                                        .includes(
                                            this.state.query.toLowerCase()
                                        ) || !this.state.query ? (
                                        <div className="p-spacer-sm m-b-spacer-md">
                                            <a
                                                href={torontoUrlValue}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="hover-grow ec-border-radius-sm prim-font ec-primary-font--regular text-dark background-trans-light-grey p-spacer-md no-border full-width text-left flex-justify-between flex flex-align-center"
                                            >
                                                Find groups in Toronto
                                                <FontAwesomeIcon
                                                    icon={faExternalLink}
                                                />
                                            </a>
                                        </div>
                                    ) : null}{" "}
                                </li>
                            ) : null}
                        </ul>
                    </div>
                </section>
            </div>
        </div>
    );

    render() {
        return (
            <div className="filters no-overflow p-y-spacer-xl sticky-pos uptop max-vh-100 overflowing hide-scrollbars p-r-spacer-lg ec-background-white full-height no-overflow">
                <div className="border-main-grey full-height">
                    {this.content()}
                </div>
            </div>
        );
    }
}
